site.spjallmenni = site.spjallmenni || {};

site.spjallmenni = {
	init: function () {
		$(document).ready(function () {
			// Create and load the script
			const script = document.createElement('script');
			script.src = "https://chatbot-api.menni.ai/api/widget?secretKey=sk_99d339be818e42a5aca57183f7219285f40b22efa5746ce74ca28f38230f0362&position=bottom-right";
			script.async = true;

			// Add load event handler
			script.onload = function() {
				console.log('Chatbot widget loaded successfully');
			};

			// Add error event handler
			script.onerror = function(error) {
				console.error('Failed to load chatbot widget', error);
			};

			// Append the script to the document
			document.body.appendChild(script);
		});
	},
};

